import { Component, OnInit } from '@angular/core';
import { UnityService } from 'src/app/services/unity.service';
import { Unity } from 'src/app/models/unity';
import { CustomerService } from 'src/app/services/customer.service';
import { UnitTypeService } from 'src/app/services/unit-type.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from 'src/app/models/customer';
import { UnitType } from 'src/app/models/unit-type';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/services/user.service';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { ToastrManager } from 'ng6-toastr-notifications';
import { SapProject } from 'src/app/models/sap-project';
import { SapProjectService } from 'src/app/services/sap-project.service';

@Component({
  selector: 'app-unity',
  templateUrl: './unity.component.html',
  styleUrls: ['./unity.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NativeDateAdapter}]
})
export class UnityComponent implements OnInit {
  loading:boolean = false;
  type:string;
  unitiesAll:Unity[] = [];
  unitiesTemp:Unity[] = [];
  isActive:boolean = true;
  unity:Unity = new Unity();
  customers:Customer[] = [];
  types:UnitType[] = [];
  users:User[] = [];
  sapProjects:SapProject[] = [];

  editUnity:boolean = true;
  isMachinery:boolean = false;

  //Pagination
  public page:number = 1;
  public pagination:number = 10;

  //Searching
  public find:string = '';

  constructor(private unityServ:UnityService, private customerServ:CustomerService, private unitTyeServ:UnitTypeService, private actRoute:ActivatedRoute, private modalService: NgbModal, private unitTypeServ:UnitTypeService, private utl:UtilitiesService, private authServ:AuthService, private userServ:UserService, private toastr: ToastrManager, private projectServ:SapProjectService) { 
    this.actRoute.params.subscribe(params => {
      this.loading = true;
      this.isMachinery = (this.authServ.isExactly('machinery') || this.authServ.isExactly('staff'));

      this.unityServ.getFilteredUnities(params.type).then(unities => {
        this.unitiesAll = unities.filter(uni=>uni.unit_type.name!='Contratistas');
        this.filterUnities();
        this.loading = false;

        if(params.type) {
          this.type = this.unitiesAll.find(x => x.unit_type_id == params.type).unit_type.name;
        }
      });
      
      this.userServ.getUsers().then(users => {
        this.users = users;
        if(!this.isMachinery) {
          this.unity.user = this.users[0];
        }
      });
    });
  }

  ngOnInit() {
    this.editUnity = this.authServ.can('store-unity');
    this.unitTypeServ.getTypes().then(types => {
      if(this.isMachinery) {
        this.types = types.filter(x => x.id > 12);
      } else {
        this.types = types;
      }
      this.unity.unit_type = this.types[0];
      this.unity.unit_type_id = this.types[0].id;
    });
    this.customerServ.getCustomers('Compañia,Intercompañia').then(customers => {
      this.customers = customers;
      this.unity.customer = this.customers[0];
      this.unity.customer_id = this.customers[0].id;
    });
    this.projectServ.getProjects().then(projects => {
      this.sapProjects = projects;
      this.unity.sap_project = this.sapProjects[0].prjCode;
    });
  }

  filterUnities(){
    this.unitiesTemp = this.unitiesAll.filter(unity => unity.active === this.isActive);
    this.utl.search(this.unitiesTemp, ['id', 'brand', 'model', 'ubication', 'licence_plate', 'gas_type'], this.find, 'id', users => this.unitiesTemp = users);
  }

  changeUnitType() {
    if (this.unity.unit_type_id == 20) {
      this.unity.customer_type = 'Fisica';
    } else {
      this.unity.customer_type = null;
    }
  }

  show(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'bigger' });
  }

  async add(event) {
    try {
      event.preventDefault();
      
      this.loading = true;
      if(this.isMachinery) {
        this.unity.user_id = this.authServ.getActualUser().id;
      } else {
        this.unity.user_id = this.unity.user.id;
      }
      let resp = await this.unityServ.postUnity(this.unity);
      this.unitiesAll.push(resp);
      this.modalService.dismissAll();
      this.filterUnities();
      this.loading = false;
      this.toastr.successToastr('La unidad se ha creado correctamente');
    } catch(e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
      this.loading = false;
    }
  }

}
